import { useAuth } from '@/lib/auth/auth';
import { type PublicProfileResult } from '@/lib/api/apiTypes';
import { useQuery } from '@tanstack/react-query';

export const publicProfileKeys = {
  all: ['public-profile'] as const,
  detail: (username: string) => ['public-profile', username] as const,
};

export function usePublicProfile(username?: string) {
  const request = useAuth((state) => state.request);
  const accessToken = useAuth((state) => state.session?.accessToken);

  return useQuery({
    queryKey: username ? publicProfileKeys.detail(username) : publicProfileKeys.all,
    enabled: Boolean(username),
    queryFn: async () => {
      if (!username) {
        throw new Error('Missing username');
      }

      void accessToken;
      return request<PublicProfileResult>(`/profiles/${username}`, {
        analyticsAction: 'load_profile',
      });
    },
  });
}
